import controller from './storeSelect.controller';
import template from './storeSelect.html';

const storeSelectComponent = {
  restrict: 'E',
  bindings: {
    callback: '&',
    cashPage: '='
  },
  controller,
  template
};

export default storeSelectComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/storeSelect.component.js
 **/